module.exports = __webpack_public_path__ + "97b138df984276830853e122dbd0ec88.svg";